<template>
    <div class="event-list-item">
        <div class="inner-event-wrapper">
            <div class="details">
                <router-link :to="{ name: 'eventDetails', params: { slug: event.slug }}"><p class="title heading-3">{{event.name}}</p></router-link>
                <div class="detail-list">
                    <p class="line-item"><strong>Date:</strong> <span>{{ parsedStartDate }}</span> <span v-if="parsedEndDate !== '' && parsedEndDate != parsedStartDate"> to </span> <span v-if="parsedEndDate !== '' && parsedEndDate != parsedStartDate">{{ parsedEndDate }}</span></p>
                    <p class="line-item"><strong>Time:</strong> {{event.startTime}} <span v-if="event.endTime !== ''"> to {{ event.endTime }}</span></p>
                    <p class="line-item"><strong>Location:</strong> {{ event.eventStoreLocation }}</p>
                </div>
                <router-link class="event-detail-button" :to="{ name: 'eventDetails', params: { slug: event.slug }}"><a href="" class="btn">More Info</a></router-link>
            </div>
            <div class="image">
                <router-link :to="{ name: 'eventDetails', params: { slug: event.slug }}">
                    <div v-if="event.image && event.image !== ''" class="event-image" v-bind:style="{'background-image' : 'url(' + event.image + ')'}"></div>
                    <div class="inner-background-default" v-if="event.image === ''">
                        <img src="https://cdn.shopify.com/s/files/1/0330/3299/4860/files/background_logo.png?v=1584731378" alt="Snow Peak Event">
                        <p>Snow Peak Event</p>
                    </div>
                </router-link>
            </div>
        </div>
        <div></div>
    </div>
</template>

<style lang="scss" scoped>
    @import "../scss/_variables";

    .event-list-item {
        margin-bottom: 30px;
        border-bottom: solid 1px $c-border;
        min-height: 380px; // ADD MOBILE HEIGHT
        height: 1px;
        background: $c-white;

        @media(max-width: 767px) {
            min-height: unset;
            height: unset;
        }

        .inner-event-wrapper {
            display: flex;
            height: 100%;

            @media(max-width: 767px) {
                flex-direction: column-reverse;
            }

            .details {
                width: 50%;
                padding: 60px;
                display: flex;
                flex-direction: column;

                @media(max-width: 991px) {
                    padding: 30px;
                }

                @media(max-width: 767px) {
                    width: 100%;
                    padding: 30px;
                }

                .title {
                    margin-bottom: 30px;
                    letter-spacing: normal;
                }

                .detail-list {
                    margin-bottom: 60px;

                    @media(max-width: 991px) {
                        margin-bottom: 30px;
                    }

                    strong {
                        font-weight: bold;
                    }
                }

                .event-detail-button {
                    margin-top: auto;

                    .btn {
                        border-color: #000;
                    }
                }
            }

            .image {
                width: 50%;
                background: #eee;
                overflow: hidden;
                transition: opacity 0.3s ease;

                &:hover {
                    opacity: 0.8;
                }

                @media(max-width: 767px) {
                    width: 100%;
                    height: 300px;
                }


                a {
                    width: 100%;
                    height: 100%;
                    display: block;

                    .event-image {
                        width: 100%;
                        height: 100%;
                        background-size: cover;
                        background-position: center center;
                    }
                }

                .inner-background-default {
                    width: 100%;
                    height: 100%;
                    background: #eee;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;

                    @media(max-width: 767px) {
                        min-height: 200px;
                    }

                    img {
                        max-width: 80px;
                    }

                    p {
                        font-size: 26px;
                        margin-top: 15px;
                        color: $c-bg-text-color;
                    }
                }
            }
        }

        .store-location {
            text-transform: uppercase;
        }
    }
</style>

<script>
    export default {
        data() {
            return {
                parsedStartDate: '',
                parsedEndDate: '',
                monthNames: {
                    1: 'January',
                    2: 'February',
                    3: 'March',
                    4: 'April',
                    5: 'May',
                    6: 'June',
                    7: 'July',
                    8: 'August',
                    9: 'September',
                    10: 'October',
                    11: 'November',
                    12: 'December'
                }
            }
        },
        props: ['event'],
        computed: {
            parsedDescription() {
                const doc = new DOMParser().parseFromString(this.event.description, "text/html");
                return doc.documentElement.textContent;
            }
        },
        created: function () {
            this.parsedStartDate = this.parseStartDate(this.event);
            this.parsedEndDate = this.parseEndDate(this.event);
        },
        mounted: function () {

        },
        methods: {
            parseStartDate: function (event) {

                //refactor to account for comma
                return `${this.getMonthName(event.startDateMonth)} ${event.startDateDay}, ${event.startDateYear}`;
            },
            parseEndDate: function (event) {

                // refactor to accoutn for comma
                return `${this.getMonthName(event.endDateMonth)} ${event.endDateDay}, ${event.endDateYear}`;
            },
            getMonthName: function (name) {
                if (name !== '') {
                    const month = parseInt(name);
                    if (Number.isInteger(month)) {
                        return this.monthNames[month];
                    } else {
                        '';
                    }
                } else {
                    return '';
                }
            }
        }
    }
</script>
